// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".white-space-pre > *[data-v-701ac82d] {\n  white-space: pre;\n}", ""]);
// Exports
module.exports = exports;
